import { render } from "./TradesByDateChartComponent.vue?vue&type=template&id=6d859baa&scoped=true"
import script from "./TradesByDateChartComponent.vue?vue&type=script&lang=js"
export * from "./TradesByDateChartComponent.vue?vue&type=script&lang=js"

import "./TradesByDateChartComponent.vue?vue&type=style&index=0&id=6d859baa&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d859baa"]])

export default __exports__